/** Curo's two booleans; true is "Do Not Allow", null is not synced yet (DBO-1575). */
export type DeliveryPreferences = {
  doNotEmail: boolean | null;
  doNotSms: boolean | null;
};

export const NOT_SYNCED: DeliveryPreferences = {doNotEmail: null, doNotSms: null};

const part = (doNot: boolean | null | undefined, channel: string) =>
  doNot === null || doNot === undefined
    ? null
    : `${doNot ? 'Do not allow' : 'Allow'} ${channel}`;

/** "Allow email, Do not allow SMS"; a part still at null is left out, both null is empty. */
export const formatDeliveryPreferences = (
  preferences: DeliveryPreferences | undefined
): string =>
  [part(preferences?.doNotEmail, 'email'), part(preferences?.doNotSms, 'SMS')]
    .filter((text): text is string => text !== null)
    .join(', ');
